import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "_change-status _modal bg-white" }
const _hoisted_2 = { class: "_modal__content px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"none\"><path d=\"M29.8034 3.38292C15.2228 3.38292 3.36674 15.3238 3.36674 30.001C3.36674 44.6762 15.2228 56.6171 29.8034 56.6171C44.3839 56.6171 56.2452 44.6762 56.2452 30.001C56.2452 15.3238 44.3839 3.38292 29.8034 3.38292ZM29.8034 60C13.3737 60 0 46.5418 0 30.001C0 13.4582 13.3737 0 29.8034 0C46.2382 0 59.6068 13.4582 59.6068 30.001C59.6068 46.5418 46.2382 60 29.8034 60Z\" fill=\"#E37056\"></path><path d=\"M52.5556 30.0008C52.5556 42.6491 42.3702 52.9023 29.8016 52.9023C17.2381 52.9023 7.05273 42.6491 7.05273 30.0008C7.05273 17.3515 17.2381 7.09775 29.8016 7.09775C42.3702 7.09775 52.5556 17.3515 52.5556 30.0008Z\" fill=\"#F4C870\"></path><path d=\"M29.7892 36.6177C29.0372 36.6177 28.3904 36.8826 27.869 37.408C27.3527 37.9313 27.0869 38.5748 27.0869 39.3217C27.0869 40.1721 27.3677 40.8489 27.9242 41.3324C28.4606 41.8028 29.0973 42.041 29.8192 42.041C30.5311 42.041 31.1628 41.7993 31.6943 41.3228C32.2457 40.8323 32.5215 40.159 32.5215 39.3217C32.5215 38.5733 32.2508 37.9278 31.7193 37.4045C31.1879 36.8811 30.5362 36.6177 29.7892 36.6177Z\" fill=\"white\"></path><path d=\"M27.7136 31.5484V31.56C27.8088 32.5688 27.9743 33.3092 28.2049 33.8225C28.4907 34.4377 29.0171 34.7627 29.729 34.7627C30.4259 34.7627 30.9523 34.4326 31.2581 33.8073C31.5188 33.2739 31.6792 32.5471 31.7544 31.5882L32.4112 24.024C32.4864 23.3154 32.5215 22.6084 32.5215 21.923C32.5215 20.7012 32.361 19.7806 32.0352 19.1074C31.7845 18.5835 31.208 17.9602 29.9095 17.9602C29.0723 17.9602 28.3804 18.2454 27.859 18.8056C27.3476 19.3592 27.0869 20.1243 27.0869 21.0797C27.0869 21.71 27.1321 22.7567 27.2273 24.1941L27.7136 31.5484Z\" fill=\"white\"></path></svg></div><div class=\"_modal__content__title text-neutral-700 font-semibold text-2xl mt-5\"> Bạn có muốn khoá tài khoản này? </div>", 2)
const _hoisted_5 = { class: "text-center text-neutral-500 mt-2" }
const _hoisted_6 = { class: "w-full mt-5" }
const _hoisted_7 = {
  class: "mt-2",
  id: `list-dropdown-1`
}
const _hoisted_8 = { class: "bg-neutral-50 flex items-center justify-between p-3 border rounded-t cursor-pointer" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  class: "px-4 border border-t-0 rounded-b",
  id: `list-dropdown-1-content`
}
const _hoisted_11 = { class: "flex items-start" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_14 = { class: "ml-4 text-orange-600 font-semibold whitespace-pre-wrap w-40" }
const _hoisted_15 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.terminology('teacher')) + " này hiện vẫn đang phụ trách buổi học can thiệp cá nhân. Vui lòng thay đổi " + _toDisplayString(_ctx.$filters.terminology('teacher')) + " cho các học sinh bên dưới bằng cách cập nhật lại thời khóa biểu của cơ sở. ", 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, " Danh sách học sinh " + _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " này đang dạy có trong TKB ", 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.data.length) + " Học sinh", 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "py-4"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    (item?.profile_photo?.w200)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "shadow-sm inline-block h-6 w-6 rounded-full",
                          src: item?.profile_photo?.w200,
                          alt: ""
                        }, null, 8, _hoisted_12))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                          style: _normalizeStyle({
											background:
												item?.profile_photo?.default
													?.color,
										})
                        }, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(item?.profile_photo?.default
													?.initial), 1)
                        ], 4))
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, " Hủy "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/schedule/timetable')))
      }, " Cập nhật Thời khóa biểu ")
    ])
  ]))
}